import React, { useEffect, useState, useRef } from "react";
import SignageItemService from "../../../services/SignageItemService";
import SignageItem from "../../../types/contracts/responses/SignageItem";
import { useSearchParams } from "react-router-dom";

const SignageSlideshow: React.FC = () => {
    const [items, setItems] = useState<SignageItem[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [iterationCount, setIterationCount] = useState(0);
    const videoRef = useRef<HTMLVideoElement>(null);

    const [searchParams] = useSearchParams();
    const soundEnabled = searchParams.get("sound") === "1";

    const fetchItems = async () => {
        try {
            const data = await SignageItemService.getAll();
            setItems(data ?? []);
            setCurrentIndex(0);
            setIterationCount(prev => prev + 1);
        } catch (err) {
            console.error("Failed to fetch signage items", err);
        }
    };

    useEffect(() => {
        fetchItems();
    }, []);

    const playNext = async () => {
        if (items.length === 0) return;

        let nextIndex = currentIndex + 1;
        if (nextIndex >= items.length) {
            await fetchItems();
            return;
        }

        setCurrentIndex(nextIndex);
    };

    const handleEnded = () => {
        playNext();
    };

    const handleError = () => {
        console.warn(`Failed to load video: ${items[currentIndex].assetUrl}, skipping...`);
        playNext();
    };

    if (items.length === 0) {
        return <div>Loading videos...</div>;
    }

    return (
        <div style={{ width: "100%", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <video
                ref={videoRef}
                key={`${items[currentIndex].id}-${iterationCount}`}
                src={items[currentIndex].assetUrl}
                autoPlay
                muted={!soundEnabled}
                controls={false}
                onEnded={handleEnded}
                onError={handleError}
                style={{ maxWidth: "100%", maxHeight: "100%" }}
            />
        </div>
    );
};

export default SignageSlideshow;
